import React, { Component } from 'react';
import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Fade from 'react-reveal/Fade';

import '../css/WhyNexuniPage.css';

class WhyNexuniPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      hero: {
        zh: "為什麼選擇 NEXUNI？",
        en: "Why NEXUNI?",
        ja: "なぜ NEXUNI？"
      },
      heroSub: {
        zh: "我們不只提供設備，更交付能真正上工的完整解決方案。",
        en: "We don't just provide equipment. We deliver complete solutions that work.",
        ja: "私たちは単なる設備ではなく、現場で機能する完全なソリューションを提供します。"
      },
      differentiators: [
        {
          title: { zh: "Universal Robots 認證合作夥伴", en: "Certified Universal Robots Partner", ja: "Universal Robots 認定パートナー" },
          desc: { zh: "Nexuni 是 Universal Robots 認證的 Solution Provider 與 Distributor，具備豐富的協作機器人整合經驗。", en: "Nexuni is a certified Solution Provider and Distributor for Universal Robots, with extensive cobot integration experience.", ja: "Nexuni は Universal Robots の認定ソリューションプロバイダーおよびディストリビューターです。" },
          icon: "/assets/mainpage_nexuni_white_icon.png"
        },
        {
          title: { zh: "NVIDIA Inception 新創成員", en: "NVIDIA Inception Member", ja: "NVIDIA Inception メンバー" },
          desc: { zh: "深度整合 NVIDIA 軟硬體平台，開發最先進的 AI 機器人技術。", en: "Deeply integrating NVIDIA's hardware and software platforms to develop cutting-edge AI robotics.", ja: "NVIDIA のハードウェアおよびソフトウェアプラットフォームを深く統合し、最先端の AI ロボティクスを開発。" },
          icon: "/assets/mainpage_nexuni_white_icon.png"
        },
        {
          title: { zh: "台灣 + 新加坡雙據點", en: "Taiwan + Singapore Presence", ja: "台湾 + シンガポール拠点" },
          desc: { zh: "新竹總部與新加坡辦公室，服務亞太區域客戶，具備跨國部署能力。", en: "Hsinchu HQ and Singapore office, serving Asia-Pacific clients with cross-border deployment capabilities.", ja: "新竹本社とシンガポールオフィスで、アジア太平洋地域のクライアントにサービスを提供。" },
          icon: "/assets/mainpage_nexuni_white_icon.png"
        }
      ],
      stats: [
        { num: "30+", label: { zh: "停車場部署", en: "Parking Lots Deployed", ja: "駐車場展開" } },
        { num: "3000+", label: { zh: "管理車格", en: "Parking Spaces Managed", ja: "駐車スペース管理" } },
        { num: "13", label: { zh: "新加坡工廠", en: "Singapore Factories", ja: "シンガポール工場" } },
        { num: "80%", label: { zh: "焊接設定時間減少", en: "Welding Setup Time Reduced", ja: "溶接セットアップ時間短縮" } }
      ],
      cta: {
        zh: "立即聯繫我們",
        en: "Get in Touch",
        ja: "お問い合わせ"
      }
    }

    this.update_lang = this.update_lang.bind(this)
    this.navigate = this.navigate.bind(this)
  }

  componentDidMount() {
    updateSEO('why_nexuni', this.state.lang, '/why-nexuni');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const lang = this.state.lang;

    return (
      <div className={"why_nexuni_page " + lang}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={[{ label: { zh: "為何選擇我們", en: "Why Nexuni", ja: "なぜNexuni" } }]} />

        <div className="why_hero_section">
          <Fade duration={1000} delay={200}>
            <h1 className="why_hero_title">{this.state.hero[lang]}</h1>
            <p className="why_hero_sub">{this.state.heroSub[lang]}</p>
          </Fade>
        </div>

        <div className="why_diff_section">
          {this.state.differentiators.map((item, idx) => (
            <Fade duration={1000} delay={300 + idx * 200} key={idx}>
              <div className="why_diff_card">
                <img src={item.icon} alt="" className="why_diff_icon" />
                <h3>{item.title[lang]}</h3>
                <p>{item.desc[lang]}</p>
              </div>
            </Fade>
          ))}
        </div>

        <div className="why_stats_section">
          {this.state.stats.map((stat, idx) => (
            <Fade duration={1000} delay={200 + idx * 150} key={idx}>
              <div className="why_stat_item">
                <span className="why_stat_num">{stat.num}</span>
                <span className="why_stat_label">{stat.label[lang]}</span>
              </div>
            </Fade>
          ))}
        </div>

        <div className="why_cta_section">
          <Fade duration={1000} delay={400}>
            <button className="why_cta_btn" onClick={() => this.navigate('/contact')}>
              {this.state.cta[lang]}
            </button>
          </Fade>
        </div>

        <Footer lang={lang} navigate={this.navigate} />
      </div>
    );
  }
}

export default WhyNexuniPage;
